function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M384 265H128v-17h256v17z"
});

const SvgIosRemove = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosRemove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-remove.6cff426f.svg";
export { ForwardRef as ReactComponent };